import classNames from 'classnames'
import {VmButton, VmView} from 'components'
import {listStatusMessage} from './entries'
import {forwardRef, useImperativeHandle, useState} from 'react'
import {isFunction} from 'utils'

function Tabs({onChangeTab: propsonChangeTab = null, ...props}, ref) {
  const showlog = false
  const listTabs = listStatusMessage
  const [activetab, setactivetab] = useState(0)
  const onChangeTab = (tab, title = '') => {
    if (showlog) {
      console.log('tab, title', tab, title)
    }
    setactivetab(tab)
    if (isFunction(propsonChangeTab)) {
      propsonChangeTab(tab, title)
    }
  }
  useImperativeHandle(
    ref,
    () => {
      if (showlog) {
        console.log('useImperativeHandle')
      }
      return {
        activetab,
        setactivetab,
      }
    },
    [activetab]
  )
  return (
    <VmView className="flex flex-row min-h-[2.5rem] mb-4 overflow-x-scroll">
      {listTabs.map((im, index) => {
        const active = index === activetab
        return (
          <VmButton
            key={`im-listTabs-${im?.title || '-'}-${index}`}
            className={classNames(
              'flex justify-center items-center !flex-none text-sm p-2 px-4 mr-4 !min-w-[50px]',
              active
                ? '!bg-blue1-payment !text-white'
                : '!bg-white !text-black2-payment'
            )}
            hidering={true}
            onClick={() => !active && onChangeTab(index, im?.title)}
          >
            {im?.title || '-'}
          </VmButton>
        )
      })}
    </VmView>
  )
}
export default forwardRef(Tabs)
